import Swiper from "swiper";
export default () => ({
  swiper: null,
  initSlider() {
    this.swiper = new Swiper(this.$refs.slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      rewind: true,
    });
  },
});
